import { createGsapCore } from '../utils/gsap';


interface AnimationDefinition {
        timelineId: string;
        createAnimation: (timeline: gsap.core.Timeline) => void;
        scrollTrigger?: {
            trigger: string | Element;
            config?: ScrollTrigger.Vars;

        };
    }

    class AnimationManager {
        private gsapCore = createGsapCore();
        private animations: AnimationDefinition[] = [];

        public registerAnimation(animation: AnimationDefinition) {
            this.animations.push(animation);
        }

        public async initializeAnimations(): Promise<void> {
            // Process animations sequentially to avoid race conditions
            for (const animation of this.animations) {

                try {
                    const timeline = this.gsapCore.createTimeline(animation.timelineId, {
                        defaults: { duration: 1, ease: 'power2.out' },
                        onComplete: () => {
                            console.log(`Animation ${animation.timelineId} completed!`);
                        },
                    });



                    // Cast the timeline to the expected type
                    animation.createAnimation(timeline as gsap.core.Timeline);


                    if (animation.scrollTrigger) {
                        await this.gsapCore.addScrollTrigger(
                            animation.timelineId,
                            animation.scrollTrigger.trigger,
                            animation.scrollTrigger.config || {} // Provide default empty object
                        );
                    }
                } catch (error) {
                    console.error(`Failed to initialize animation ${animation.timelineId}:`, error);
                }
            }
        }

        public playTimeline(timelineId: string) {
            this.gsapCore.playTimeline(timelineId);
        }

        public pauseTimeline(timelineId: string) {
            this.gsapCore.pauseTimeline(timelineId);
        }
    }

    export const animationManager = new AnimationManager();